import { Injectable } from '@angular/core';
import Analytics from "analytics";
import googleTagManager from "@analytics/google-tag-manager";
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '@api';
import { SlideshowModel } from '@core/Models/slideshow-model';
import { BoothBannerModel, ExhibitorModel, ProductModel } from '@core/Models/exhibitor.model';
const analytics = Analytics({
  app: "kprexpohybrid2022",
  plugins: [
    googleTagManager({
      containerId: "GTM-KP2V2HC",
    }),
  ],
});
declare var submitMeiro: Function;
declare var submitPixel: Function;

@Injectable({
  providedIn: 'root'
})
export class GTMService {

  constructor(
    private auth:AuthService,
    private http: HttpClient,
    private router: Router
  ) { }

  GTMPageLoadUser(page:any, pageslug:any) {

    // this.sendAnalytic("view", pageslug)
    //   .subscribe((res) => {});
    //console.log('GTMPageLoadUser', page, pageslug);


    if(this.auth.users()){

      let data:any = {
        'breadcrumb_detail' : page,
        'login_type': '',
        'user_id' :  this.auth.users()?.id
      }

      // if(user.getCode()){
      //   data.login_type = 'Invitation'
      // }else{
      //   data.login_type = 'Personal'
      // }
      data.login_type = 'Personal'

      this.sendAnalyticDatalayer('view', 'pageload', data).subscribe();

      analytics.page(data);

    }else{

      let data:any = {
        'breadcrumb_detail' : page,
        'login_type': '',
        'user_id' :  ''
      }

      this.sendAnalyticDatalayer('view', 'pageload', data).subscribe();
      analytics.page(data);

    }

  }

  GTMSubmitRegister(action:any, type:any, user_id:any){

    let data = {
      'user_activity': action,
      'event_category': action,
      'login_type': type,
      'user_id': user_id
      }


      analytics.track('usersession',data);

  }

  GTMSubmitForm(data:any){

    analytics.track('formsubmission',data);


  }

  sendTrackingGA(trackingEvent:any, data:any) {
    analytics.track(trackingEvent, data);

  }

  sendAnalytic(type:any, action:any) {
    let body = new FormData();

    body.append("api_key", '4beb8c17dcd729e28c3193b5d1a948579926f7e713ad08970c0e85816c7f564d');
    body.append("type", type);
    body.append("action", action);
    body.append("additional_data", localStorage['dataGlobal']);
    return this.http.post<any>(`${environment.urlAnalytic}`, body);
  }

  sendAnalyticDatalayer(type:any, action:any, data:any) {

    // var additional_data :[any] = [data];
    this.eventSubmitPixel(action, data)
    //console.log('GTMPageLoadUser', 'sendAnalyticDatalayer');

    let body = new FormData();

    body.append("api_key", '4beb8c17dcd729e28c3193b5d1a948579926f7e713ad08970c0e85816c7f564d');
    body.append("type", type);
    body.append("action", action);
    body.append("additional_data", JSON.stringify(data));
    return this.http.post<any>(`${environment.urlAnalytic}`, body);
  }

  meiroEventSubmitContactForm(tag:any, form:any){

    submitMeiro(tag, form);

  }

  eventSubmitPixel(action:any, form:any){
    submitPixel(action, form);
  }


  gtmDownloadPdf(data:{button_name?:string,file_name?:string,url_download?:string }){

    let push:any = {
      event:'leads_engagement',
      engagement_action: data.button_name,
      engagement_detail: data.file_name,
      destination_page_url: data.url_download
    }

    this.sendTrackingGA('leadsengagement', push);
    this.sendAnalyticDatalayer('click', 'leadsengagement', push).subscribe();

  }

  GTMSubmitSurveyForm(form:any, status:any) {

    let data:any = {
      event:'form_survey',
      event_category: 'Form Submission',
      form_name: "Survey",
      form_step: "Step 1 - Submit Survey", //step-based form journey based on page load
      Form_submit_status: status,
      form_reference_id: "0", //passed on every form step
      form_detail: form,
    }

    this.sendAnalyticDatalayer('click', 'formsubmission', data).subscribe();
    return analytics.track('formsubmission',data);


  }

  gtmBtnLeadsEngagement(event_category:string, btnName:string, page:string, url:string){

    var isValidUrl:boolean = true;

    if(url){
      isValidUrl = url.includes('https') || url.includes('http');
    }

    var dataAnalyticJoin = {
      'event': 'leads_engagement',
      'event_category': event_category, //
      'engagement_action': btnName, //button name
      'engagement_detail': page, //landing page
      'destination_page_url': isValidUrl ? url : environment.webUrl+url //
      }


    this.sendTrackingGA('leadsengagement',dataAnalyticJoin);
    this.sendAnalyticDatalayer('click', 'formsubmission', dataAnalyticJoin).subscribe();

    // this.GTMCustomEventClick('tag')

  }

  gtmPromotionClick(name:string, id:string, brand:string, section:string){

    //console.log(name);

    var dataAnalyticJoin = {
      'event': 'promotion_click',
      'promotion_name': this.removeHTMLTags(name), //promo name
      'promotion_id': id, //
      'promotion_brand': brand, //
      'promotion_category': section, //section name
      }

    this.sendTrackingGA('promotionclick',dataAnalyticJoin);
    this.sendAnalyticDatalayer('click', 'promotionclick', dataAnalyticJoin).subscribe();

    // this.GTMCustomEventClick('tag')

  }

  gtmFaqClick(category:string, name:string){

    var dataAnalyticJoin = {
      'event': 'faq_tracking',
      'faq_category': category,
      'faq_name': this.removeHTMLTags(name) //faq dropdown name
    }

    this.sendTrackingGA('faqtracking',dataAnalyticJoin);
    this.sendAnalyticDatalayer('click', 'faqtracking', dataAnalyticJoin).subscribe();

    // this.GTMCustomEventClick('tag')

  }

  gtmCategoryClick(name:string){

    var dataAnalyticJoin = {
      'event': 'category_click',
      'category': name //or Hatchback
      }

    this.sendTrackingGA('categoryclick',dataAnalyticJoin);
    this.sendAnalyticDatalayer('click', 'categoryclick', dataAnalyticJoin).subscribe();

    // this.GTMCustomEventClick('tag')

  }

  gtmLeadsEngagement(tag:string, category:string, location:string){

    var dataAnalyticJoin = {'leads_action': tag, 'product_name':'','product_id':'','product_category': category,'product_brand':'','product_location':location,'product_price':'','page_url': window.location.href};
    this.sendTrackingGA('leadsengagement',dataAnalyticJoin);
    this.sendAnalyticDatalayer('click', 'leadsengagement', dataAnalyticJoin).subscribe();

    // this.GTMCustomEventClick('tag')

  }

  gtmLeadsEngagementExhibitor(detail:ExhibitorModel, tag:string, category:string, location:string){

    var dataAnalyticJoin = {'leads_action': tag, 'product_name':detail.name,'product_id':detail.id,'product_category': category,'product_brand':detail.name,'product_location':location,'product_price':'','page_url': window.location.href};
    this.sendTrackingGA('leadsengagement',dataAnalyticJoin);
    this.sendAnalyticDatalayer('click', 'leadsengagement', dataAnalyticJoin).subscribe();

  }

  gtmBrandClick(detail:ExhibitorModel, category:string, from:string, index:number, location:any, serachkeyword:string, provinsi:string){

    var dataAnalyticJoin = {
      'event': 'brand_click',
      'brand_id': detail.id, //
      'brand_name': detail.name, //
      'list': from,
      'position': 'slot ' + Math.abs(index + 1), //or slot 2
      //applicable if user performs a search
      'search_query': serachkeyword == '' ? 'N/A' : serachkeyword, //Cari Developer/Agen (can be N/A)
      'form_detail_1': provinsi, //Provinsi (can be N/A)
      'form_detail_2': location, //Kota (can be N/A)
      };
    this.sendTrackingGA('brandclick',dataAnalyticJoin);
    this.sendAnalyticDatalayer('click', 'brandclick', dataAnalyticJoin).subscribe();

  }

  gtmProductClick(detail:ProductModel, category:string, from:string, index:number, location:any, price:any = '', brand:string){

    var dataAnalyticJoin2 =  {
      'event': 'product_click',
      'product_id': detail.id, //
      'product_name': detail.name, //
      'product_category': category, //or Apartement
      'product_brand': brand,
      'product_location': location,
      'product_price': price,
      'list': from,
      'position': 'slot ' + Math.abs(index + 1) //or slot 2
      };
    this.sendTrackingGA('productclick',dataAnalyticJoin2);
    this.sendAnalyticDatalayer('click', 'productclick', dataAnalyticJoin2).subscribe();

  }

  gtmProductDetailLoad(detail:ProductModel, category:string, location:any, price:any = '', brand:string){

    var dataAnalyticJoin2 =  {
      'event': 'product_detail',
      'product_id': detail.id, //
      'product_name': detail.name, //
      'product_category': category, //
      'product_brand': brand, //Merk kendaraan
      'product_location': location,
      'product_price': price,
      };
    this.sendTrackingGA('productdetail',dataAnalyticJoin2);
    this.sendAnalyticDatalayer('view', 'productdetail', dataAnalyticJoin2).subscribe();

  }

  gtmProductimpression(detail:ProductModel, category:string, from:string, index:number, location:any, price:any = '', brand:string){

    var dataAnalyticJoin2 = {'event': 'product_impression','product_brand':brand, 'product_name': detail.name ,'product_id': detail.id ,'product_category': category ,'product_location': location ,'product_price': price,'list': from, 'position' : 'slot ' + Math.abs(index + 1)};
    this.sendTrackingGA('productimpression',dataAnalyticJoin2);
    this.sendAnalyticDatalayer('view', 'productimpression', dataAnalyticJoin2).subscribe();

  }

  gtmProductDetailimpression(detail:ProductModel, category:string, from:string, index:number, location:any, price:any = ''){

    var dataAnalyticJoin2 = {'event': 'product_detail_impression','product_name': detail.name ,'product_id': detail.id ,'product_category': category ,'product_location': location ,'product_price': price,'list': from, 'position' : 'slot ' + Math.abs(index + 1)};
    this.sendTrackingGA('productimpression',dataAnalyticJoin2);
    this.sendAnalyticDatalayer('view', 'productimpression', dataAnalyticJoin2).subscribe();

  }

  gtmPromoSlideshowClick(detail:SlideshowModel, from:string, index:number, brand:string){

    var dataAnalyticJoin = {'event': 'promotion_click','promotion_brand':brand,'promotion_id': detail.id ,'promotion_category':brand ,'promotion_name': detail.name ,'promotion_creative': 'banner','list':from, 'position' : 'slot ' + Math.abs(index + 1)};
    this.sendTrackingGA('promotionclick',dataAnalyticJoin);
    this.sendAnalyticDatalayer('click', 'promotionclick', dataAnalyticJoin).subscribe();


  }

  gtmPromoSlideshowImpresion(detail:SlideshowModel, from:string, index:number, brand:string){

  var dataAnalyticJoin = {'event': 'promotion_impression','promotion_brand':brand,'promotion_id': detail.id ,'promotion_category':brand ,'promotion_name': detail.name ,'promotion_creative': 'banner', 'position' : 'slot ' + Math.abs(index + 1)};
  this.sendTrackingGA('promotionimpression',dataAnalyticJoin);
  this.sendAnalyticDatalayer('view', 'promotionimpression', dataAnalyticJoin).subscribe();


  }

  gtmPromoBannerClick(detail:BoothBannerModel, from:string, index:number, type:string){

    var dataAnalyticJoin = {'event': 'promotion_click','promotion_brand':type,'promotion_id': detail.id ,'promotion_category':type ,'promotion_name': detail.name ,'promotion_creative': 'banner', 'list':from, 'position' : 'slot ' + Math.abs(index + 1)};
    this.sendTrackingGA('promotionclick',dataAnalyticJoin);
    this.sendAnalyticDatalayer('click', 'promotionclick', dataAnalyticJoin).subscribe();

  }

  gtmPromoBannerImpresion(detail:BoothBannerModel, from:string, index:number, type:string){

  var dataAnalyticJoin = {'event': 'promotion_impression','promotion_brand':type,'promotion_id': detail.id ,'promotion_category':type ,'promotion_name': detail.name ,'promotion_creative': 'banner', 'list':from, 'position' : 'slot ' + Math.abs(index + 1)};
  this.sendTrackingGA('promotionimpression',dataAnalyticJoin);
  this.sendAnalyticDatalayer('view', 'promotionimpression', dataAnalyticJoin).subscribe();

  }

  // gtmPromoNewsClick(detail:NewsModel, from:string, index:number){

  //   var dataAnalyticJoin = {'event': 'promotion_click','promotion_brand':'','promotion_id': detail.getID() ,'promotion_category':'' ,'promotion_name': detail.getTitle() ,'promotion_creative': 'banner', 'list':from, 'position' : 'slot ' + Math.abs(index + 1)};
  //   this.sendTrackingGA('promotionclick',dataAnalyticJoin);
  //   this.sendAnalyticDatalayer('click', 'promotionclick', dataAnalyticJoin).subscribe();

  // }

  // gtmPromoNewsImpresion(detail:NewsModel, from:string, index:number){

  // var dataAnalyticJoin = {'event': 'promotion_impression','promotion_brand':'','promotion_id': detail.getID() ,'promotion_category':'' ,'promotion_name': detail.getTitle() ,'promotion_creative': 'banner', 'position' : 'slot ' + Math.abs(index + 1)};
  // this.sendTrackingGA('promotionimpression',dataAnalyticJoin);
  // this.sendAnalyticDatalayer('view', 'promotionimpression', dataAnalyticJoin).subscribe();


  // }

  gtmSearchEngangement(query:any, category:string){

    let data = {
      'event': 'searchengagement',
      'search_query': query,
      'page_url': window.location.href,
      'search_category': category
    }

    this.sendTrackingGA('searchengagement',data);
    this.sendAnalyticDatalayer('click', 'searchengagement', data).subscribe();

  }

  gtmContentEngagement(action:string, article:string){

    let data = {
      'event': 'content_engagement',
      'engagement_action': action,
      'article_name': article,
      'page_url': window.location.href
    }

    this.sendTrackingGA('content_engagement',data);
    this.sendAnalyticDatalayer('click', 'content_engagement', data).subscribe();

  }

  GTMOutbondClick(target:string) {

    let data = {
      'event_action': target,
      'event_label': window.location.href,
      }

    this.sendAnalyticDatalayer('click', 'outbound_link', data).subscribe();
    ;
    return analytics.track('outbound_link', data);
  }

  GTMCustomEventClick(target:string) {

    let data = { action: "button_click", item: target}

    submitMeiro('customEvent', data);
    this.sendAnalyticDatalayer('click', 'button_click', data).subscribe();
  }

  gtmSimulasiBtnClick(data:any,){

    var dataAnalyticJoin = data;
    this.sendTrackingGA('simulasikan_kpr_simulasi',dataAnalyticJoin);
    this.sendAnalyticDatalayer('click', 'simulasikan_kpr_simulasi', dataAnalyticJoin).subscribe();

  }

  GeckoCustomEventClick(target:string) {

    let data = { action: "button_click", item: target}

    this.sendAnalyticDatalayer('click', 'button_click', data).subscribe();
  }

  removeHTMLTags(text:string) {
    if(text){
      return text ? text.replace(/<[^>]*>?/gm, '') : '';
    }else{
      return '';
    }

  }

  gtmLogout() {
    var dataAnalyticJoin = {
      'event': 'user_logout',
      'invitation_code': this.auth.users()!.code, //or BCA12345
      'user_id': this.auth.users()!.id, //null user id
      };
    this.GTMSubmitForm(dataAnalyticJoin);
  }

}

